import axios from "axios";

const login = async (data) => {
  const params = {
    email: data.email,
    password: data.password,
  };

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/login`,
      params
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

const forgetpassword = async (data) => {
  const params = { email: data.email };

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/forget-password`,
      params
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const otpverify = async (data, email) => {
  const otpno = Number(data);

  const params = {
    email: email,
    otp: otpno,
  };

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/otp-verify`,
      params
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const resetpassword = async (data, email) => {
  const params = {
    email: email,
    newPassword: data,
  };
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/update-password`,
      params
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

export default login;
export { forgetpassword, otpverify, resetpassword };
